"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeRole = normalizeRole;
exports.coerceRole = coerceRole;
const tool_results_1 = require("./message-parts/tool-results");
const conventions_1 = require("../../conventions");
const json_1 = require("../utils/json");
const CANONICAL_ROLES = new Set(["system", "user", "assistant", "tool"]);
function normalizeRole(message) {
    const rawRole = message.role ?? message.author; // author: gemini/PaLM-era
    if (typeof rawRole === "string") {
        const lowered = rawRole.toLowerCase();
        for (const provider of conventions_1.registeredProviders) {
            const role = (0, json_1.ownLookup)(provider.roleByRawRole, lowered);
            if (role)
                return role;
        }
        if (CANONICAL_ROLES.has(lowered))
            return lowered;
        // Unrecognized strings are identities, not roles (e.g. LangGraph agent
        // names): the caller falls back to the contextual role and preserves the
        // raw string as `senderName`.
        return undefined;
    }
    if (typeof message.type !== "string")
        return undefined;
    for (const provider of conventions_1.registeredProviders) {
        const role = (0, json_1.ownLookup)(provider.roleByMessageType, message.type);
        if (role)
            return role;
    }
    return undefined;
}
/**
 * Role corrections that depend on the collected parts: user turns holding
 * only tool results are tool turns; tool-labeled turns without a
 * tool_call_id (koog/Traceloop-style conversions) are either mislabeled
 * assistant call batches or tool responses (the content IS the result).
 */
function coerceRole(role, value, parts) {
    if (role === "user" &&
        parts.length > 0 &&
        parts.every((part) => part.type === "tool-result")) {
        return "tool";
    }
    if (role === "tool" && !value.tool_call_id && parts.length > 0) {
        // Explicit boolean return type: TS would otherwise infer a type
        // predicate and narrow `parts` to TextPart[], rejecting the splice.
        if (parts.every((part) => part.type === "tool-call")) {
            return "assistant";
        }
        if (parts.every((part) => part.type === "text")) {
            const output = (0, tool_results_1.toolResultOutput)(parts.slice(), parts);
            parts.splice(0, parts.length, {
                type: "tool-result",
                toolCallId: null,
                output,
            });
        }
    }
    return role;
}
